// @flow
import { useAtom } from '@reatom/react'
import { PaymentType } from '@bfg/enums/PaymentTypesEnum'
// import { UtmAnalytics } from '@bfg/atoms/UtmAnalytics'
import { PaymentAtom } from '@bfg/atoms/Payment'
// import { AppConfigAtom } from '@bfg/atoms/AppConfig'

const initPaymentType = () => {
  let paymentType = PaymentType.WeeklySubscription
  // const appConfig = useAtom(AppConfigAtom)
  // const utm = useAtom(UtmAnalytics)
  // if (['roasup', 'onetime-test', 'cardpay', 'bs'].includes(utm.utmSource)) {
  //   paymentType = PaymentType.OneTimePayment
  // } else if (['weekly-test', 'cardsub', 'trial-link'].includes(utm.utmSource)) {
  //   paymentType = PaymentType.WeeklySubscription
  // } else if (utm.utmSource === 'monthly-test' || appConfig.gateway === 'braintree' || appConfig.gateway === 'bluesnap') {
  //   paymentType = PaymentType.MonthlySubscription
  // } else if (utm.utmSource === 'annual_test') {
  //   paymentType = PaymentType.AnnualSubscription
  // }
  return paymentType
}

// aPay фиксированной формы: { oneTimePay, weeklySub, monthlySub, annualSub }.
// Прежний for-of по Object.entries(aPay) крэшился под runtime'овским
// "Invalid attempt to iterate non-iterable instance" и к тому же выбирал тип
// исходя из порядка ключей (последний non-null выигрывал). Прямой доступ с
// явным приоритетом (annual > monthly > weekly > oneTime) закрывает и крэш,
// и недетерминированный выбор.
export const resolvePaymentType = (aPay) => {
  if (aPay == null) return null
  if (aPay.annualSub != null) return PaymentType.AnnualSubscription
  if (aPay.monthlySub != null) return PaymentType.MonthlySubscription
  if (aPay.weeklySub != null) return PaymentType.WeeklySubscription
  if (aPay.oneTimePay != null) return PaymentType.OneTimePayment
  return null
}

export const resolvePaymentTypeObject = (aPay)=>{
  if (aPay == null) return null
  if (aPay.annualSub != null) return aPay.annualSub
  if (aPay.monthlySub != null) return aPay.monthlySub
  if (aPay.weeklySub != null) return aPay.weeklySub
  if (aPay.oneTimePay != null) return aPay.oneTimePay
  return null
}

const usePaymentTypeResolver = () => {
  const paymentAtomState = useAtom(PaymentAtom)
  return {
    paymentType: resolvePaymentType(paymentAtomState.aPay),
    paymentTypeObject: resolvePaymentTypeObject(paymentAtomState.aPay),
  }
}

export default usePaymentTypeResolver
